<template>
    <router-view></router-view>
</template>

<script>

import router from '../router'
export default {
  name: "LoginLayout",
  mounted(){
    if(!localStorage.getItem('wax_user')) {
        router.push('/login')
    }
  },
  methods: {
    logout: function() {
      router.push('/login')
    }
  },
};
</script>